import { render, staticRenderFns } from "./CustomerStatsSection.vue?vue&type=template&id=00daab1a&scoped=true&"
import script from "./CustomerStatsSection.vue?vue&type=script&lang=js&"
export * from "./CustomerStatsSection.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStatsSection.vue?vue&type=style&index=0&id=00daab1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00daab1a",
  null
  
)

export default component.exports